module.exports = __webpack_public_path__ + "media/images/athletes/157-9e3e377622eaf814c840c351c4639029.png";